import { useState } from "react";
import { Badge } from "../../components/ui";
import { theme } from "../../lib/theme";
import { CollapsibleHeader, CollapsibleArrow } from "./styled";

export function Collapsible({
  title,
  count,
  defaultOpen = true,
  children,
}: {
  title: string;
  count?: number;
  defaultOpen?: boolean;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{ marginTop: theme.spacing.lg }}>
      <CollapsibleHeader onClick={() => setOpen((o) => !o)}>
        <CollapsibleArrow open={open}>&#9654;</CollapsibleArrow>
        {title}
        {count != null && <Badge color={theme.colors.textMuted}>{count}</Badge>}
      </CollapsibleHeader>
      {open && children}
    </div>
  );
}
